import { createReducer } from 'store/createReducer';
import { ConservatorySeasonModel } from 'models/ConservatorySeasonModel';
import { ConservatoryStepValid } from 'models/ConservatoryStepValid';
import {
  GUIDE_SEASON_DATA_LOADING,
  GUIDE_SEASON_DATA_LOADED,
  GUIDE_SEASON_PRODUCT_SELECTED,
  GUIDE_SEASON_VARIANT_SELECTED,
  GUIDE_SEASON_VALID,
  GUIDE_SEASON_INVALID,
  ConservatorySeasonAction,
  ConservatorySeasonSelectProductAction,
  ConservatorySeasonSelectVariantAction
} from './actions';
import { ConservatorySeasonProductVariantModel } from 'models/ConservatorySeasonProductVariantModel';

const seasonReducer = {
  [GUIDE_SEASON_VALID]: (state: ConservatorySeasonModel) => {
    return {
      ...state,
      isValid: ConservatoryStepValid.Valid
    };
  },
  [GUIDE_SEASON_INVALID]: (state: ConservatorySeasonModel) => {
    return {
      ...state,
      isValid: ConservatoryStepValid.Invalid
    };
  },

  [GUIDE_SEASON_DATA_LOADED]: (
    state: ConservatorySeasonModel,
    action: ConservatorySeasonAction
  ) => {
    return {
      ...state,
      products: action.products,
      dataLoading: false
    };
  },
  [GUIDE_SEASON_DATA_LOADING]: (state: ConservatorySeasonModel) => {
    return {
      ...state,
      dataLoading: false
    };
  },

  [GUIDE_SEASON_PRODUCT_SELECTED]: (
    state: ConservatorySeasonModel,
    action: ConservatorySeasonSelectProductAction
  ) => {
    return {
      ...state,
      products: state.products.map(product => {
        return {
          ...product,
          selected:
            product.productId === action.productId &&
            product.season.toLowerCase() === action.season.toLowerCase(),
          variants: product.variants.map(variant => {
            return { ...variant, selected: false };
          })
        };
      })
    };
  },

  [GUIDE_SEASON_VARIANT_SELECTED]: (
    state: ConservatorySeasonModel,
    action: ConservatorySeasonSelectVariantAction
  ) => {
    return {
      ...state,
      products: state.products.map(product => {
        if (product.selected) {
          let variantSelected = false;

          const sortedVariants = [...product.variants].sort(
            (
              a: ConservatorySeasonProductVariantModel,
              b: ConservatorySeasonProductVariantModel
            ): number => {
              if (a.width < b.width) {
                return -1;
              }
              if (a.width > b.width) {
                return 1;
              }
              if (a.length < b.length) {
                return -1;
              }
              if (a.length > b.length) {
                return 1;
              }
              return 0;
            }
          );

          return {
            ...product,
            variants: sortedVariants.map(variant => {
              let selected = false;
              let roofMultiple = 1;
              if (
                variant.width >= action.width &&
                variant.length >= action.depth &&
                !variantSelected
              ) {
                variantSelected = true;
                selected = true;
                roofMultiple = action.roofMultiple;
              }
              return {
                ...variant,
                selected,
                roofMultiple
              };
            })
          };
        }

        return product;
      })
    };
  }
};
export default createReducer(
  {
    dataLoading: false,
    isValid: ConservatoryStepValid.Unknown,
    products: []
  },
  seasonReducer
);
